export const ocplcUploadFile = `mutation uploadFile($file: Upload!, $whoChanged: String!) {
  uploadFile(file: $file, whoChanged: $whoChanged) {
    message
    status
    validationReport {
      fileName
      fileContent
    }
  }
}`;

export const bulkUpload = `mutation BulkUploadFile($file: Upload!, $loginUser: String!) {
  bulkUploadFile(file: $file, loginUser: $loginUser) {
    message
    fileErrContent
  }
}`;